import { loadCldr, setCulture } from '@syncfusion/ej2-base';

import numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
import timeData from 'cldr-data/supplemental/timeData.json';
import enCaGregorian from 'cldr-data/main/en/ca-gregorian.json';
import enNumbers from 'cldr-data/main/en/numbers.json';
import enTimeZoneNames from 'cldr-data/main/en/timeZoneNames.json';
import enGBCaGregorian from 'cldr-data/main/en-GB/ca-gregorian.json';
import enGBNumbers from 'cldr-data/main/en-GB/numbers.json';
import enGBTimeZoneNames from 'cldr-data/main/en-GB/timeZoneNames.json';
import enCACaGregorian from 'cldr-data/main/en-CA/ca-gregorian.json';
import enCANumbers from 'cldr-data/main/en-CA/numbers.json';
import enCATimeZoneNames from 'cldr-data/main/en-CA/timeZoneNames.json';
import enAUCaGregorian from 'cldr-data/main/en-AU/ca-gregorian.json';
import enAUNumbers from 'cldr-data/main/en-AU/numbers.json';
import enAUTimeZoneNames from 'cldr-data/main/en-AU/timeZoneNames.json';
import frCaGregorian from 'cldr-data/main/fr/ca-gregorian.json';
import frNumbers from 'cldr-data/main/fr/numbers.json';
import frTimeZoneNames from 'cldr-data/main/fr/timeZoneNames.json';
import frCACaGregorian from 'cldr-data/main/fr-CA/ca-gregorian.json';
import frCANumbers from 'cldr-data/main/fr-CA/numbers.json';
import frCATimeZoneNames from 'cldr-data/main/fr-CA/timeZoneNames.json';
import deCaGregorian from 'cldr-data/main/de/ca-gregorian.json';
import deNumbers from 'cldr-data/main/de/numbers.json';
import deTimeZoneNames from 'cldr-data/main/de/timeZoneNames.json';
import esMXCaGregorian from 'cldr-data/main/es-MX/ca-gregorian.json';
import esMXNumbers from 'cldr-data/main/es-MX/numbers.json';
import esMXTimeZoneNames from 'cldr-data/main/es-MX/timeZoneNames.json';
import jaCaGregorian from 'cldr-data/main/ja/ca-gregorian.json';
import jaNumbers from 'cldr-data/main/ja/numbers.json';
import jaTimeZoneNames from 'cldr-data/main/ja/timeZoneNames.json';

loadCldr(
  numberingSystems,
  timeData,
  enCaGregorian, enNumbers, enTimeZoneNames,
  enGBCaGregorian, enGBNumbers, enGBTimeZoneNames,
  enCACaGregorian, enCANumbers, enCATimeZoneNames,
  enAUCaGregorian, enAUNumbers, enAUTimeZoneNames,
  frCaGregorian, frNumbers, frTimeZoneNames,
  frCACaGregorian, frCANumbers, frCATimeZoneNames,
  deCaGregorian, deNumbers, deTimeZoneNames,
  esMXCaGregorian, esMXNumbers, esMXTimeZoneNames,
  jaCaGregorian, jaNumbers, jaTimeZoneNames
);

/**
 * Maps browser locale (navigator.language) to the nearest bundled CLDR culture.
 * Syncfusion does not perform parent-locale fallback internally — it requires
 * an exact match against the loaded CLDR data keys.
 */
const bundledCultures = [
  'en-GB', 'en-CA', 'en-AU', 'fr-CA', 'es-MX',
  'en', 'fr', 'de', 'ja'
];

export function resolveCulture ( browserLocale: string ): string {
  if ( !browserLocale ) {
    return 'en';
  }
  // Exact match first (e.g. en-GB, fr-CA)
  if ( bundledCultures.includes ( browserLocale ) ) {
    return browserLocale;
  }
  // Try base language (e.g. de-DE → de, ja-JP → ja, fr-FR → fr)
  const base = browserLocale.split ( '-' )[ 0 ];
  if ( bundledCultures.includes ( base ) ) {
    return base;
  }
  // Default to en (US English patterns)
  return 'en';
}

setCulture ( resolveCulture ( navigator.language ) );
